import { useEffect, useRef } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../lib/auth";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const match = location.hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }
    (async () => {
      try {
        const r = await axios.post(`${API}/auth/session`, { session_id: sessionId });
        setUser(r.data);
        const requestedPath = location.pathname;
        const destination = requestedPath === "/assistant"
          ? "/assistant"
          : requestedPath === "/my-bookings"
            ? "/my-bookings"
            : requestedPath === "/admin" && r.data.is_admin
              ? "/admin"
              : "/";
        window.history.replaceState({}, "", window.location.pathname);
        navigate(destination, { replace: true, state: { user: r.data } });
      } catch {
        navigate("/", { replace: true });
      }
    })();
  }, [location.hash, location.pathname, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#050505] text-zinc-500">
      <Loader2 className="animate-spin mr-2" size={20} /> Signing you in...
    </div>
  );
};
